import { FC } from 'react';

import { HelpChapterProps, HelpText } from '@pp/core';

export const HelpChapterWheelValidSpinRule: FC<HelpChapterProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <div>
      <p>
        <HelpText>{String(content.validSpin)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.completeRotations)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.noSpin)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.noSpinDeclared)}</HelpText>
      </p>
      <ul>
        <li>{String(content.spinsNotCompleted)}</li>
        <li>{String(content.pointerBetweenSegments)}</li>
        <li>{String(content.physicalInterference)}</li>
        <li>{String(content.mechanicalMalfunction)}</li>
      </ul>
      <p>
        <HelpText>{String(content.betsRefunded)}</HelpText>
      </p>
    </div>
  );
};
